import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft.jsx';
import FJUploadPanel from './upload/FJUploadPanel.jsx';
import FJTranscribeContainer from './creating/container/FJTranscribeContainer.jsx';
import FJEditPanelContainer from './edit/FJEditPanelContainer.jsx';
import useLocalStore from '../../../hooks/useLocalStore.js';

const FJTextBasedEditingLeft = () => {
    useLocalStore();
    return (
        <FJAppLeft>
            <FJUploadPanel />
            <FJTranscribeContainer />
            <FJEditPanelContainer />
        </FJAppLeft>
    );
};

export default FJTextBasedEditingLeft;
